import React from 'react';
import type { FC } from 'react';

import { DateTime } from 'luxon';

import { Button } from '@shared/components/bootstrap';

import { client } from '@admin/libraries/apollo';
import { useDispatchManageButtonEnabledQuery } from '@admin/schema';

import { canManageDispatchBoard } from './permissions';

export const DispatcherManageButton: FC<{
  mode: 'modifying' | 'viewing';
  regionID: string | null;
  date: string | null; // Always YYYY-MM-DD format
  onManage(): void;
}> = ({ mode, regionID, date, onManage }) => {
  const canManage = canManageDispatchBoard();
  const { data, loading } = useDispatchManageButtonEnabledQuery({
    client,
    variables: {
      regionID: regionID || '',
      date: date || '',
    },
    skip: !canManage || !regionID || !date || mode === 'modifying',
  });

  if (!canManage) {
    return null;
  }

  if (mode === 'modifying') {
    return null;
  }

  if (!regionID || !date) {
    return null;
  }

  const isButtonEnabled = data?.dispatchManageButtonEnabled ?? false;

  return (
    <Button kind="default" type="button" onClick={onManage} disabled={!isButtonEnabled} loading={loading}>
      Manage
    </Button>
  );
};
